import Vue from 'vue';
Vue.config.productionTip = false;

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import axios from "@/axios";
Vue.use(axios);

import components from "@/components";
Vue.use(components);

import filter from "@/filter";
Vue.use(filter);

import views from '@/views';
Vue.use(views);

import i18n from "@/i18n";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import router, { menuRoutes } from "@/router/";
import empty from '@/views/layout/routerEmpty.vue';
Vue.use(router);
menuRoutes()
    .then(router => new Vue({ i18n, render: h => h(empty), router }).$mount('#app'))
    .catch(err => window.document.write(err));

window.padLeft = function (value, len) {
    if (value != this.undefined && value != null) {
        value = value.toString();
        return value.length >= len ? value : new Array(len - value.length + 1).join("0") + value;
    } else {
        return value;
    }
}
window.toFilter = function (array) {
    return function (value) {
        const item = array.find(x => x.key == value);
        return item ? item.value : '';
    }
}